import React from "react";
import { WarningComponent as WarningIcon } from 'ui/Icons';

export enum EWarningVariant {
  YELLOW = 'yellow',
  RED = 'red',
}

const variantClassnames: Record<EWarningVariant, { container: string; icon: string }> = {
  [EWarningVariant.YELLOW]: {
    container: 'bg-yellow-advert-light border-yellow-advert',
    icon: 'yellow-advert',
  },
  [EWarningVariant.RED]: {
    container: 'bg-red-25 border-red-100',
    icon: 'red-100',
  },
};

export interface iAlertProps {
  message: string | React.ReactElement;
  description?: string | React.ReactElement;
  className?: string;
  variant?: EWarningVariant;
}

export const Warning = (props: iAlertProps) => {
  const { message, className, variant = EWarningVariant.YELLOW } = props;
  const variantClassname = variantClassnames[variant];

  return (
    <div className={`px-4 py-10px mt-25px border ${variantClassname.container} ${className ?? ''}`}>
      <div className="flex items-center justify-center">
        <WarningIcon icon={variantClassname.icon} />
        <p className="text-black text-16px leading-21px font-pt-sans ml-10px my-0 flex-1">{message}</p>
      </div>
      {props.description}
    </div>
  );
};
